//export const URL_API=`http://158.101.120.182:5000/`;
//export const URL_LOGIN="http://158.101.120.182:5000/login-google";


export const URL_API=`http://localhost:5000/`;
export const URL_LOGIN="http://localhost:5000/login-google";
